$( document ).ready(function() {
if(document.querySelectorAll('#generatePDF').length > 0){
    document.getElementById('generatePDF').addEventListener('click', function () {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
    
    let userAgent = navigator.userAgent;
    
    if (userAgent.match(/chrome|chromium|crios/i) && window.innerWidth < 992) {
    setTimeout(function () {
      var divToPrint = document.getElementById('installtion-pdf');
      var newWin = window.open('', 'Print-Window');
      newWin.document.open();
      newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');
      newWin.document.close();
      setTimeout(function () {
          newWin.close();
      }, 6000);
    }, 4000);
    } else if (userAgent.match(/safari/i) && window.innerWidth < 992) {
    setTimeout(function () {
      var htmlElement = document.querySelector("html");
      var divToPrint = document.getElementById('installtion-pdf');
      var newWin = window;
      newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');
      newWin.document.close();
      setTimeout(function () {
          newWin.document.write(htmlElement.innerHTML);
          alert("Please refresh the page");
      }, 6000);
    }, 4000);
    } else {
    setTimeout(function () {
      var markup = document.getElementsByTagName('html')[0].innerHTML;
      var mywindow = window;
      mywindow.document.write(document.getElementById('installtion-pdf').innerHTML);
      mywindow.print();
      mywindow.document.close();
      location.reload(); // Reload the page after printing?
    }, 4000);
    }
    });
    
    var Name = "Not known";
    if (navigator.appVersion.indexOf("Win") != -1) {
    Name = "Windows OS";
    } else if (navigator.appVersion.indexOf("Mac") != -1) {
    Name = "MacOS";
    } else if (navigator.appVersion.indexOf("X11") != -1) {
    Name = "UNIX OS";
    } else if (navigator.appVersion.indexOf("Linux") != -1) {
    Name = "Linux OS";
    } else {
    console.log("sorry");
    }
    
    function fnBrowserDetect() {
      let userAgent = navigator.userAgent;
      let browserName;
      var v = "Version: " + navigator.appVersion;
      console.log(navigator.appVersion);
      
      if (userAgent.match(/chrome|chromium|crios/i)) {
      var split_val = v.split("Chrome/");
      var split_again = split_val[1].split(".");
      if (split_again[0] < 108) {
        browserName = "chrome";
      } else {
        browserName = "chrome";
      }
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
      } else if (userAgent.match(/safari/i)) {
        browserName = "safari";
        $('.installation-topdetails').addClass(browserName);
      } else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
      } else if (userAgent.match(/edg/i)) {
      browserName = "edge";
      } else {
      browserName = "No browser detection";
      }
      console.log('app details', browserName);
      }
    fnBrowserDetect();
  }

    
if(document.querySelectorAll('.installation-topdetails .img-thubmnails').length > 0){

  document.querySelectorAll('.installation-topdetails .img-thubmnails').forEach(function(steps) {
      steps.querySelector('.img-container:first-child').classList.add('active');
  });

  document.querySelectorAll(".installation-topdetails .img-container img").forEach(function(element) {
    // Add mouseenter event listener
    element.addEventListener("mouseenter", function() {
        var src = this.getAttribute("src");
        // Find the closest ancestor with the class ".steps-info-block"
        var stepsInfoBlock = this.closest(".steps-info-block");
        if (stepsInfoBlock) {
            // Set the src attribute of the image inside ".main-img-container"
            var mainImg = stepsInfoBlock.querySelector(".main-img-container img");
            if (mainImg) {
                mainImg.setAttribute("src", src);
            }
            // Remove the "active" class from siblings of the parent ".img-container"
            var siblings = this.parentNode.parentNode.querySelectorAll(".img-container");
            siblings.forEach(function(sibling) {
                if (sibling !== this.parentNode) {
                    sibling.classList.remove("active");
                }
            }, this);
            // Add the "active" class to the parent ".img-container"
            this.parentNode.classList.add("active");
        }
    });
});
}
});